import { render, staticRenderFns } from "./StartTriggerBlock.vue?vue&type=template&id=c08a05d2&scoped=true"
import script from "./StartTriggerBlock.vue?vue&type=script&lang=js"
export * from "./StartTriggerBlock.vue?vue&type=script&lang=js"
import style0 from "./StartTriggerBlock.vue?vue&type=style&index=0&id=c08a05d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08a05d2",
  null
  
)

export default component.exports